import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'mds-ui/environments/environment';
import { ApplicationVO, ApplicationResponse } from '../models/application';
import { DateTimeFormatPipe } from 'mds-ui/app/shared/pipes/date-time-format.pipe';

@Injectable()
export class ApplicationService {
    dtformat = new DateTimeFormatPipe("en-US");
    private httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            "Cache-Control": "no-cache",
            Pragma: "no-cache"
        })
    }
  application: ApplicationVO = new ApplicationVO();
    constructor(private _http: HttpClient) {

    }
    getApplicationByName(name: string, username: string): Observable<ApplicationResponse[]> {
        return this._http.get<ApplicationResponse[]>(
            environment.getApplicationURl +"/"+ name + "?username=" + username + "&dateParam=" + this.dtformat.transform(new Date, ""), this.httpOptions)
            .pipe(catchError(error => { return throwError(error); }));
    }
}